module.exports = __webpack_public_path__ + "img/icon-24-ic-chev-s.87f26e78.svg";